
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import UserList from '@/components/admin/users/UserList';

const DetailedListing = () => {
  const { listType = 'users' } = useParams<{ listType: string }>();
  const navigate = useNavigate();

  // Determine page title based on list type
  const getPageTitle = () => {
    switch (listType) {
      case 'users':
        return 'Total Users';
      default:
        return 'Listing';
    }
  };

  const getPageDescription = () => {
    switch (listType) {
      case 'users':
        return 'All users registered on the platform';
      default:
        return '';
    }
  };

  return (
    <AdminLayout>
      <Helmet>
        <title>{getPageTitle()} | Admin Portal</title>
      </Helmet>

      <div className="space-y-6">
        <div>
          <Button 
            variant="ghost" 
            onClick={() => navigate('/administrator/dashboard')}
            className="mb-2"
          >
            <ChevronLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
          
          <h1 className="text-3xl font-bold tracking-tight">{getPageTitle()}</h1>
          <p className="text-gray-500">{getPageDescription()}</p>
        </div>

        {listType === 'users' && <UserList />}
      </div>
    </AdminLayout>
  );
};

export default DetailedListing;
